import React, {Component} from 'react';
import {DocumentTitle, Spinner, ValidatingInput, Page, Form, Icon} from '../widgets';
import parseQueryString from '../parseQueryString';
import FancyButton from '../widgets/FancyButton';
import {postJson} from '../fetchJson';
import fetchJson from '../fetchJson';
import {uiActions} from '../chrome';
import {connect} from 'react-redux';
import sessionActions from './session.actions';

class VerifyEmail extends Component {
	constructor() {
		super();

		const query = parseQueryString(window.location.search);

		this.state = {
			token: query && query.token,
			email: query && query.email,
			tokenValidity: !query || !query.email || !query.token ? false : null,
			verifyComplete: false
		};

		// Check validity of token before asking user to confirm password.
		if (this.state.tokenValidity === null) {
			postJson(
				`/api/user/${encodeURIComponent(query.email)}/verify?token=${encodeURIComponent(
					query.token
				)}`
			)
				.then(result => {
					this.setState({tokenValidity: true, verifyComplete: true});
					this.props.usernameChanged(query.email);
				})
				.catch(e => {
					this.setState({tokenValidity: false, verifyComplete: true});
				});
		}

		this.onError = () => {
			this.setState({tokenValidity: false});
		};
	}

	render() {
		return (
			<DocumentTitle title="B2Me">
				<Page className="password-reset">
					<section>
						{this.state.verifyComplete && this.state.tokenValidity ? (
							<Success
								showLogin={this.props.showLogin}
								currentSession={this.props.currentSession}
							/>
						) : null}
						{this.state.verifyComplete && !this.state.tokenValidity ? (
							<InvalidToken tryAgain={this.props.tryAgain} />
						) : null}
						{!this.state.verifyComplete ? <ValidatingToken /> : null}
					</section>
				</Page>
			</DocumentTitle>
		);
	}
}

class Success extends Component {
	render() {
		return (
			<div>
				<h1>
					<Icon name="thumb_up" size={200} /> Email verified
				</h1>
				<p>
					Email address successfully verified.
					{this.props.currentSession && this.props.currentSession.user ? (
						undefined
					) : (
						<span>
							You can now <FancyButton onClick={this.props.showLogin}>Login</FancyButton> to{' '}
							<em>B2Me</em>
						</span>
					)}
				</p>
			</div>
		);
	}
}

class ValidatingToken extends Component {
	render() {
		return (
			<div>
				<p>Validating token...</p>
				<Spinner />
			</div>
		);
	}
}

class InvalidToken extends Component {
	render() {
		return (
			<div>
				<h1>
					<Icon name="error" size={200} />
					Invalid token
				</h1>
				<p>This verification token is invalid or has expired</p>
				<p>
					If this is unexpected and continues to occur, please contact{' '}
					<a href="https://b2me.zendesk.com">B2Me support.</a>
				</p>
			</div>
		);
	}
}

const ConnectedVerifyEmail = connect(
	state => ({
		currentSession: state.session && state.session.current
	}),
	dispatch => ({
		showLogin: () => dispatch(uiActions.uiModal('login')),
		usernameChanged: username => dispatch(sessionActions.sessionUsernameChanged(username))
	})
)(VerifyEmail);

export default ConnectedVerifyEmail;



// WEBPACK FOOTER //
// ./src/user/VerifyEmail.js